import React from "react";
import { TypographyStyled } from "./TypographyStyled";
import { TypographyProps } from "../../entities/Typography";

const Typography: React.FC<TypographyProps> = ({
  type,
  children,
}: TypographyProps) => (
  <TypographyStyled className={type}>
    <p>{children}</p>
  </TypographyStyled>
);

export default Typography;
